// @flow
import Properties from "../../Properties.js";
import { getInit, postInit, deleteInit } from "../types/constants";
import { setCookie, getCookie } from "../functions/cookies";

const root = Properties.api_root;

export function getConferenceId(name: string, callBack: Function) {
  return (dispatch: any) => {
    fetch(root + "/api/v2/conferences/" + name + "?type=name", getInit)
      .then(function (response: Response) {
        if (response.ok) {
          return response.json();
        } else {
          callBack && callBack("");
          return Promise.reject();
        }
      })
      .then(function (json) {
        dispatch({ type: "SET_CONFERENCEID", conference: json });
        callBack &&
          callBack(
            json.display_name,
            json.sub_heading,
            json.has_logo,
            json.id,
            json.expired
          );
      })
      .catch((err) => {
        console.error(err);
      });
  };
}

export function getUserInfo(
  conferenceId: string,
  accessToken: string,
  conferenceName: string,
  Callback: Function
) {
  return (dispatch: any) => {
    fetch(
      root + "/api/v2/conferences/" + conferenceId + "/people/" + accessToken,
      getInit
    )
      .then(function (response: Response) {
        if (response.ok) {
          return response.json();
        } else {
          Callback(false);
          return Promise.reject();
        }
      })
      .then(function (json) {
        if (conferenceName !== "") {
          setCookie("access_token", accessToken, conferenceName);
        }
        //dispatch({ type: "SAVE_ACCESSCODE", accessCode: accessToken });
        dispatch({ type: "SET_USER", user: json });
        Callback(true);
        return json.enrolments;
      })
      .then(function (enrolments) {
        dispatch(getEnrolments(conferenceId, accessToken, enrolments));
      });
  };
}

export function updateUser(field: string, value: string) {
  return (dispatch: any) => {
    dispatch({ type: "UPDATE_USER", field: field, value: value });
  };
}

export function getEnrolments(
  conferenceId: string,
  accessToken: string,
  enrolments: Array<string>,
  personUid?: string
) {
  return (dispatch: any) => {
    if (!personUid) {
      dispatch({ type: "CLEAR_ENROLMENT" });
    }
    for (var i = 0; i < enrolments.length; i++) {
      dispatch(
        getImageForEnrolment(
          conferenceId,
          accessToken,
          enrolments[i],
          personUid
        )
      );
    }
  };
}

export function saveToken(token: string) {
  return (dispatch: any) => {
    dispatch({ type: "SAVE_TOKEN", token: token });
  };
}

export function detectImage(faces: Object) {
  return (dispatch: any) => {
    dispatch({ type: "DETECT_IMAGE", detectedFaces: faces });
  };
}

export function enrolSingle(conferenceId: string, faces: Object) {
  const accessToken = getCookie("access_token");
  let formData = new FormData();
  formData.append("faces", JSON.stringify([faces]));
  return (dispatch: any) => {
    fetch(
      root +
        "/api/v2/conferences/" +
        conferenceId +
        "/people/" +
        accessToken +
        "/enrolments",
      postInit(formData)
    )
      .then(function (response: Response) {
        return response.json();
      })
      .then(function (json) {
        dispatch(getImageForEnrolment(conferenceId, accessToken, json[0]));
      });
  };
}

export function getImageForEnrolment(
  conferenceId: string,
  accessToken: string,
  enrolmentId: string,
  personUid?: string
) {
  return (dispatch: any) => {
    if (personUid) {
      dispatch({ type: "SET_UPDATING", status: true });
    }
    fetch(
      root +
        "/api/v2/conferences/" +
        conferenceId +
        "/people/" +
        accessToken +
        "/enrolments/" +
        enrolmentId +
        "/image",
      getInit
    )
      .then(function (response: Response) {
        if (response.status === 200) {
          return response.blob();
        } else {
          return Promise.reject();
        }
      })
      .then(function (blob) {
        let objectURL = URL.createObjectURL(blob);
        if (personUid) {
          dispatch({ type: "SET_UPDATING", status: false });
          dispatch({
            type: "ADMIN_PERSON_APPEND",
            person_id: personUid,
            face_url: objectURL,
          });
        } else {
          dispatch({
            type: "ADD_ENROLMENT",
            enrolment_uid: enrolmentId,
            face_url: objectURL,
          });
        }
      })
      .catch(() => {
        if (personUid) {
          dispatch({ type: "SET_UPDATING", status: false });
        }
      });
  };
}

export function deleteEnrolment(conferenceId: string, enrolmentId: string) {
  const accessToken = getCookie("access_token");
  return (dispatch: any) => {
    fetch(
      root +
        "/api/v2/conferences/" +
        conferenceId +
        "/people/" +
        accessToken +
        "/enrolments/" +
        enrolmentId,
      deleteInit()
    )
      .then(function (response: Response) {
        return response.json();
      })
      .then(function (json) {
        dispatch({ type: "DELETE_ENROLMENT", enrolmentId: enrolmentId });
      });
  };
}

export function saveResults(results: object) {
  return (dispatch: any) => {
    dispatch({ type: "SAVE_RESULTS", results: results });
  };
}

export function clearState() {
  return (dispatch: any) => {
    dispatch({ type: "CLEAR_STATE" });
  };
}

export function getAllUsers(
  conferenceId: string,
  accessToken: string,
  callBack: Function,
  errorBack: Function,
  person_uid: string = ""
) {
  return (dispatch: any) => {
    dispatch({ type: "SET_UPDATING", status: true });
    fetch(
      root +
        "/api/v2/conferences/" +
        conferenceId +
        "/admin/" +
        accessToken +
        "/users?rate=100" +
        (person_uid !== "" ? "&person_uid=" + person_uid : ""),
      getInit
    )
      .then(function (response: Response) {
        if (response.ok) {
          return response.json();
        } else {
          errorBack && errorBack();
          return Promise.reject();
        }
      })
      .then(function (json) {
        if (person_uid === "") {
          dispatch({ type: "CLEAR_ADMIN" });
        }
        dispatch({ type: "ADMIN_PEOPLE_COUNT", count: json.count });
        dispatch({
          type: "ADMIN_LIST_PEOPLE",
          people: json.people,
          sendTime: Date.now(),
        });
        for (let i = 0; i < json.people.length; i++) {
          dispatch(
            getEnrolments(
              conferenceId,
              accessToken,
              json.people[i].enrolments,
              json.people[i].uid
            )
          );
        }
        dispatch({ type: "SET_UPDATING", status: false });
        callBack && callBack();
      })
      .catch(() => {
        dispatch({ type: "SET_UPDATING", status: false });
      });
  };
}

export function comparePrevPhoto(
  conferenceId: string,
  token: string,
  eyes: string,
  returnCall: Function
) {
  const accessToken = getCookie("access_token");
  let formData = new FormData();
  formData.append("token", token);
  formData.append("eyes", eyes);
  formData.append("min_match_quality", 0.5);
  return (dispatch: any) => {
    fetch(
      root +
        "/api/v2/conferences/" +
        conferenceId +
        "/people/" +
        accessToken +
        "/compare",
      postInit(formData)
    )
      .then(function (response: Response) {
        return response.json();
      })
      .then(function (json) {
        returnCall(json.match);
      })
      .catch((err) => {
        console.error(err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/global/actions/databaseActions.js